<script setup>
import { computed } from 'vue';
const props = defineProps({
    clicavel: Boolean,
    class: String
})

const classes = computed(() => {
    return [
        'border-1 surface-border p-4 md:p-5 bg-white border-round-lg',
        props.class,
        { 'hover:shadow-1 cursor-pointer': props.clicavel }
    ];
});
</script>

<template>
    <div :class="classes" :style="props.style">
        <div class="title">
            <slot name="titutulo"></slot>
        </div>
        <div class="content">
            <slot name="conteudo"></slot>
        </div>
    </div>
</template>
